import { ChangeEvent, useState } from "react";
import { useAsyncEffect } from "../../helper/hooks/async-hooks";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LoginHeader } from "../../components/login/LoginHeader";
import { ErrorMessage } from "../../components/login/ErrorMessage";
import { InputField } from "../../components/login/InputField";
import { PassResetModal } from "../../components/login/PassResetModal";
import { Footer } from "../../components/common/Footer";
import { checkPasswordUrl } from "../../components/login/checkPasswordUrl";
import { passResetValidate} from "../../components/login/passResetValidate";
import { updatePassword } from "../../components/login/updatePassword";
import { useCookies } from "react-cookie";
import { CookieSetOptions } from 'universal-cookie'

export interface passResetProps {
    name: string,
    password1: string,
    password2: string
}

/**
 * 
 * @returns パスワード再設定画面
 */
export function Reilogspf002() {
    const navigate = useNavigate();

    //  Cookieの有効期限:　7日間
    const _7_DayBySeconds = 60 * 60 * 24 * 7;

    //  パスワードを保存するcookie
    const [cookiePass, setCookiePass, removeCookiePass] = useCookies(['passCookie'])
    const passOptions: CookieSetOptions = {
        path: '/login',
        maxAge: _7_DayBySeconds
    }

    //  アカウントIDを保存するcookie
    const [cookieAccId, setCookieAccId, removeCookieAccId] = useCookies(['idCookie']);
    const accIdOptions: CookieSetOptions = {
        path: '/',
        maxAge: _7_DayBySeconds
    }

    //  対応会員番号を保存するcookie（秘書の場合のみ）
    const [cookieSecAccId, setCookieSecAccId, removeCookieSecAccId] = useCookies(['secIdCookie'])
    const secAccIdOptions: CookieSetOptions = {
        path: '/',
        maxAge: _7_DayBySeconds
    }

    //  メールアドレスを保存するcookie
    const [cookieMail, setCookieMail, removeCookieMail] = useCookies(['mailCookie']);
    const mailOptions: CookieSetOptions = {
        path: '/',
        maxAge: _7_DayBySeconds
    }

    //  ロータリーCDを保存するcookie
    const [cookieRotaryCd, setCookieRotaryCd, removeCookieRotaryCd] = useCookies(['rotaryCookie'])
    const rotaryCdOptions: CookieSetOptions = {
        path: '/',
        maxAge: _7_DayBySeconds
    }

    // モーダルの表示状態を保持するstate
    const [isModal, setIsModal] = useState(false);

    //  再設定完了済みか否かを保持するstate
    const [isChange, setIsChange] = useState(false)

    //  ロータリーCDを保持するstate
    const [rotaryCd, setRotaryCd] = useState<string>("");

    //  入力値を保持するstate
    const [passChangeInput, setPassChangeInput] = useState<passResetProps>({
        name: "",
        password1: "",
        password2: ""
    })

    //  エラーメッセージを保持するstate
    const [errorMsg, setErrorMsg] = useState<string[]>([]);

    //  inputタグへの入力をstateに保存する関数
    const inputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setPassChangeInput({
            ...passChangeInput,
            [name]: [value]
        });
    };

    //  クエリパラメータ取得
    const [searchParams, setSearchParams] = useSearchParams({url: ""})
    const url = searchParams.get('url')??''
    
    //  初回レンダリング時、変更済みか否か確認する
    useAsyncEffect(async() => {
        //  urlで登録されているか確認
        const isResetComplete = await checkPasswordUrl({url: url});

        //  登録されていない場合、ノットページに遷移
        if(Object.keys(isResetComplete).length  === 0){
            navigate('/notpage');

        }else {
            //  ロータリーCDをstateに保存
            setRotaryCd(isResetComplete.rotary_cd)
            if(isResetComplete.update_flag === true){
                //  パスワード変更済みの場合
                setIsChange(true);
                setIsModal(true);
            }
        }

    },[]);

    /**
     * 変更ボタン押下時の入力チェック
     */
    const onClickChange = async () => {
        const passResetProps: passResetProps = {
            //  氏名の空白除去
            name:      (passChangeInput.name[0])?.replace(/[ 　]/g, ''),
            password1: (passChangeInput.password1[0]),
            password2: (passChangeInput.password2[0])
        }
        
        const error = passResetValidate(passResetProps)

        if(error.length > 0){
            window.scrollTo({
                top:0,
                behavior: "smooth",
            })
            setErrorMsg(error);
            return;
        }

        //  エラーがなければメッセージクリア
        setErrorMsg([]);

        //  DB登録、更新処理
        const response = await updatePassword({
            userName: passResetProps.name,
            password:   passResetProps.password1,
            url:    url,
            rotaryCd:  rotaryCd
        })

        if(response){
            setIsModal(true);
            //  全てのcookieを削除
            removeCookieAccId('idCookie', accIdOptions);
            removeCookieSecAccId('secIdCookie', secAccIdOptions);
            removeCookieMail('mailCookie', mailOptions);
            removeCookiePass('passCookie', passOptions);
            removeCookieRotaryCd('rotaryCookie', rotaryCdOptions);
        }else{
            setErrorMsg(['入力された氏名は登録されていません。'])
        }
    }


    return(
        <div className="l-wrapper sp-view">
           <main className={`l-login ${isModal && "is-modal"}`} id="modal1">
                <form>
                    <div className="l-inner">
                    <LoginHeader />
                        <div className="login-wrap">
                            <div className="l-title">
                                <h2 className="title-txt">パスワード変更</h2>
                            </div>

                            {/* <!-- エラーメッセージエリア --> */}
                            {errorMsg.length > 0 &&
                                <ErrorMessage 
                                    messages={errorMsg} />
                            }
                            

                            <div className="form-area">
                                <InputField 
                                    title={'氏名'} 
                                    type={'text'} 
                                    name={'name'} 
                                    value={passChangeInput.name} 
                                    onChange={inputChange}
                                />

                                <InputField 
                                    title={'新しいパスワード'} 
                                    type={'password'} 
                                    name={'password1'} 
                                    value={passChangeInput.password1} 
                                    onChange={inputChange}
                                />

                                <InputField 
                                    title={'新しいパスワード'} 
                                    type={'password'} 
                                    name={'password2'} 
                                    value={passChangeInput.password2} 
                                    onChange={inputChange}
                                />

                                <div className="flex-center"><span className="att-txt">※パスワードは半角英数字・記号を交えて8文字以上50文字以内で入力してください</span></div>
                            </div>
                            <div className="btn-area flex-column col1">
                                <button
                                    type='button'
                                    className="btn-main btnsz-l"
                                    onClick={() => {
                                        onClickChange()
                                    }}>
                                        変更
                                </button>
                            </div>

                            {/** モダールエリア */}
                            <PassResetModal 
                                isChange={isChange}
                            />

                            <div className="overlay-bg"></div>
                        </div>
                    </div>
                </form>
            </main>

            <Footer />
        </div>
    );
}